import { render, staticRenderFns } from "./myFirstDay.vue?vue&type=template&id=5f64da48&scoped=true"
import script from "./myFirstDay.vue?vue&type=script&lang=js"
export * from "./myFirstDay.vue?vue&type=script&lang=js"
import style0 from "./myFirstDay.vue?vue&type=style&index=0&id=5f64da48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f64da48",
  null
  
)

export default component.exports